import axios from 'axios';
import QS from 'qs';
import MD5 from 'md5.js';
import {host} from "../config";
import store from '../store/index';
import JsEncrypt from 'jsencrypt'

axios.defaults.withCredentials = true;

export function resizeParams(params={}){
    let nonce = Math.random();
    let timestamp = Date.now();
    let signParams = `20980`;
    signParams += "nonce=" + nonce + "&timestamp=" + timestamp
    let cryptFirst = new JsEncrypt();
    cryptFirst.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDk9AbMLOAD+Ay2daYS+GwkgwyUxlsCi7SBa6tQZjAK4Vbd/l/dZTnqv2tZLD4EpZSO2CEb/KX5CUvK8pq/htE+LJ+UmqLyKD5wAVkp2qixpZPTpidFT3WPEOhHgw3oPau1kwlJJXGsG1E2CQHS4aOUNvcp2w5POpEyWVYdsj7pewIDAQAB");
    let sign = cryptFirst.encrypt(signParams);
    sign = encodeURIComponent(sign)
    params.nonce = nonce;
    params.timestamp = timestamp;
   return Object.assign({sign},params)
}


/**
 * post方法，对应post请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求参数
 */
export function $post(url, params={}) {
    let _params = resizeParams(params)
    return new Promise((resolve, reject) => {
        axios.post(host+url, QS.stringify(_params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err =>{
                reject(err)
            })
    });
}

/**
 * get方法，对应get请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 */
export function $get(url, params={}) {
    let _params = resizeParams(params)
    return new Promise((resolve, reject) =>{
        axios.get( host + url, {
            params:_params
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err)
        })
    });

}

export function fileUpload(url,file){
    return new Promise(resolve => {
        axios({
            method: 'post',
            url: host+url,
            headers: {
                Accept: '*/*'
            },
            data: file,
            processData: false,
            contentType: false,
        }).then((res)=>{
            resolve(res.data)
        })
    })
}

// axios.interceptors.response.use(function (response) {
//     return response;
//   }, function (error) {
//     return Promise.reject(error);
//   });

